<template>
  <div class="container mt-5">
    <!-- Order Summary Section -->
    <h4>My Orders</h4>
    <hr />
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="tab1-tab"
          data-bs-toggle="tab"
          data-bs-target="#tab1"
          type="button"
          role="tab"
          aria-controls="tab1"
          aria-selected="true"
        >
          In Progress
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="tab2-tab"
          data-bs-toggle="tab"
          data-bs-target="#tab2"
          type="button"
          role="tab"
          aria-controls="tab2"
          aria-selected="false"
        >
          Delivered
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="tab3-tab"
          data-bs-toggle="tab"
          data-bs-target="#tab3"
          type="button"
          role="tab"
          aria-controls="tab3"
          aria-selected="false"
        >
          Cancelled
        </button>
      </li>
    </ul>

    <!-- Tabs content -->
    <div v-if="!isLoading" class="tab-content mt-4" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="tab1"
        role="tabpanel"
        aria-labelledby="tab1-tab"
      >
        <div v-if="ordersInProgress.length" class="order-summary">
          <order-details :ordersList="ordersInProgress" />
        </div>
        <div v-else class="alert alert-info">
          You haven't ordered anything yet.
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="tab2"
        role="tabpanel"
        aria-labelledby="tab2-tab"
      >
        <div v-if="ordersDelivered.length" class="order-summary">
          <order-details :ordersList="ordersDelivered" />
        </div>
        <div v-else class="alert alert-info">You have no delivered order.</div>
      </div>
      <div
        class="tab-pane fade"
        id="tab3"
        role="tabpanel"
        aria-labelledby="tab3-tab"
      >
        <div v-if="ordersCanceled.length" class="order-summary">
          <order-details :ordersList="ordersCanceled" />
        </div>
        <div v-else class="alert alert-info">
          None of your order is cancelled yet!
        </div>
      </div>
    </div>

    <div v-else class="text-center m-5">
      <div class="spinner-border mb-2" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BASE_URL } from "@/globals";
import OrderDetails from "./OrderDetails.vue";

export default {
  name: "OrdersComponent",
  components: { OrderDetails },
  data() {
    return {
      ordersInProgress: [],
      ordersDelivered: [],
      ordersCanceled: [],
      isLoading: false,
      errorMessage: null,
    };
  },
  mounted() {
    this.fetchOrderHistory();
  },
  methods: {
    async fetchOrderHistory() {
      try {
        this.isLoading = true;
        const token = this.$store.getters.token;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const response = await axios.get(
          `${BASE_URL}/api/orders/order/userToken`,
          { headers }
        );
        if (response.data?.reason === 'INVALID_TOKEN') {
          this.$store.dispatch("logout");
          setTimeout(() => {
            this.$router.push('/login')
          }, 300);
        }
        this.ordersInProgress = response.data.ordersInProgress;
        this.ordersDelivered = response.data.ordersDelivered;
        this.ordersCanceled = response.data.ordersCanceled;
      } catch (error) {
        if (error.response.data?.reason === 'INVALID_TOKEN') {
          this.$store.dispatch("logout");
          setTimeout(() => {
            this.$router.push('/login')
          }, 300);
        } else {
          this.errorMessage = error.response.data.message;
          this.$root.showToast({
            message: this.errorMessage,
            status: "success",
            duration: 3000,
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
}
</style>
